import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1, 0, 0, 0),
    },
    orderContainer: {
      padding: theme.spacing(2, 0),
    },
    infoSubtitle: {
      color: theme.palette.text.secondary,
    },
  })
);
